<po-page-dynamic-search
  [p-actions]="pageActions"
  [p-filters]="searchFilters"
  [p-literals]="searchLiterals"
  p-concat-filters="true"
  (p-quick-search)="onQuickSearch($event)"
  (p-advanced-search)="onAdvancedSearch($event)"
  (p-change-disclaimers)="onChangeDisclaimers($event)"
>
  <app-period-filter [period]="period" (periodChange)="onPeriodChange($event)"></app-period-filter>

  <po-table
    [p-columns]="columns"
    [p-items]="items"
    p-striped="true"
    p-spacing="small"
    [p-height]="tableFit.height"
    [p-loading]="loading"
    [p-show-more-disabled]="allLoaded"
    [p-loading-show-more]="loadingShowMore"
    [p-literals]="{ noData: 'Nenhuma alteração registrada' }"
    (p-show-more)="onShowMore()"
  >
    <ng-template p-table-cell-template let-column="column" let-row="row">
      <po-tag *ngIf="column.property === 'action'" [p-value]="row.actionTag.label" [p-color]="row.actionTag.color" [p-text-color]="row.actionTag.textColor"></po-tag>
      <ng-container *ngIf="column.property === 'details'">
        <div *ngIf="row.roles.length; else detailsText" class="audit-roles">
          <span *ngFor="let r of row.roles" [title]="r.key"><po-tag [p-value]="r.label" [p-color]="r.color" [p-text-color]="r.textColor"></po-tag></span>
        </div>
        <ng-template #detailsText>{{ row.details }}</ng-template>
      </ng-container>
    </ng-template>
  </po-table>
</po-page-dynamic-search>
